module.exports = __webpack_public_path__ + "static/DY1-85620bf2bd858abd0467cb671b825aff.jpg";